import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ScheduleRow from 'pages/pga-coach/dashboard/todays-schedule/schedule-row'
import useScheduleStyles from 'pages/pga-coach/dashboard/todays-schedule/styles'
import { getBookingEventKey } from './calendar-utils'
import useCalendarStyles from './calendar-styles'

const CalendarListView = ({
  days,
  bookingsByDate,
  onReschedule,
  onPayment,
  onCancellation,
}) => {
  const classes = useCalendarStyles()
  const scheduleClasses = useScheduleStyles()

  return (
    <>
      {days.map(day => {
        const dateKey = day.toISODate()
        const dayBookings = bookingsByDate[dateKey] || []

        return (
          <Box key={dateKey} className={classes.listSection}>
            <Typography className={classes.listSectionHeader}>
              {day.toFormat('cccc, LLLL d')}
            </Typography>
            {dayBookings.length > 0 ? (
              <Box className={`${scheduleClasses.list} ${classes.listRows}`}>
                {dayBookings.map(booking => (
                  <ScheduleRow
                    key={getBookingEventKey(booking)}
                    booking={booking}
                    onReschedule={onReschedule}
                    onPayment={onPayment}
                    onCancellation={onCancellation}
                    showDateLabel={false}
                  />
                ))}
              </Box>
            ) : (
              <Typography className={classes.listSectionEmpty}>
                Nothing scheduled.
              </Typography>
            )}
          </Box>
        )
      })}
    </>
  )
}

CalendarListView.propTypes = {
  days: PropTypes.arrayOf(PropTypes.object).isRequired,
  bookingsByDate: PropTypes.object.isRequired,
  onReschedule: PropTypes.func,
  onPayment: PropTypes.func,
  onCancellation: PropTypes.func,
}

export default CalendarListView
